/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_Added_OnInputs */

const es_user_profile_devices_added_on = /** @type {(inputs: User_Profile_Devices_Added_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregado el`)
};

const en_user_profile_devices_added_on = /** @type {(inputs: User_Profile_Devices_Added_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added on`)
};

/**
* | output |
* | --- |
* | "Added on" |
*
* @param {User_Profile_Devices_Added_OnInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_added_on = /** @type {((inputs?: User_Profile_Devices_Added_OnInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_Added_OnInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_added_on(inputs)
	return en_user_profile_devices_added_on(inputs)
});
export { user_profile_devices_added_on as "user.profile.devices.added_on" }